import React from 'react';
import Spinner from '@atlaskit/spinner';
import BackendPage from '../../layout/BackendPage';

const SpinWhenLoading = () => {
  return (
    <BackendPage>
      <Spinner />
    </BackendPage>
  );
};

export default SpinWhenLoading;
